// extracted by mini-css-extract-plugin
export default {"modal":"ProjectModal_modal__OvLDB"};